const STYLE = `
:host { all: initial; }
*, *::before, *::after { box-sizing: border-box; }
.dw-layer {
  position: fixed; inset: 0; pointer-events: none; z-index: 2147483646;
}
.dw-mount { position: relative; width: 100%; height: 100%; }
svg.dw-svg { position: absolute; inset: 0; display: block; }
.dw-dim { pointer-events: auto; }
`;
/** Ensures a single <dw-tour-root> with an open ShadowRoot exists under <body>. */
export function ensureTourRoot(options = {}) {
    let host = document.querySelector('dw-tour-root');
    const created = !host;
    if (!host) {
        host = document.createElement('dw-tour-root');
        document.body.appendChild(host);
    }
    const shadow = host.shadowRoot ?? host.attachShadow({ mode: 'open' });
    // idempotent structure
    let style = shadow.querySelector('style[data-dw-root]');
    if (!style) {
        style = document.createElement('style');
        style.setAttribute('data-dw-root', '');
        style.textContent = STYLE;
        shadow.appendChild(style);
    }
    let layer = shadow.querySelector('.dw-layer');
    if (!layer) {
        layer = document.createElement('div');
        layer.className = 'dw-layer';
        shadow.appendChild(layer);
    }
    if (typeof options.zIndex !== 'undefined') {
        const z = typeof options.zIndex === 'number' ? String(options.zIndex) : options.zIndex;
        if (z && layer.style.zIndex !== z)
            layer.style.zIndex = z;
    }
    let mount = layer.querySelector('.dw-mount');
    if (!mount) {
        mount = document.createElement('div');
        mount.className = 'dw-mount';
        layer.appendChild(mount);
    }
    let svg = layer.querySelector('svg.dw-svg');
    if (!svg) {
        svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.classList.add('dw-svg');
        svg.setAttribute('width', '100%');
        svg.setAttribute('height', '100%');
        const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        const mask = document.createElementNS('http://www.w3.org/2000/svg', 'mask');
        mask.setAttribute('id', 'dw-hole-mask');
        const full = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        full.setAttribute('x', '0');
        full.setAttribute('y', '0');
        full.setAttribute('width', '100%');
        full.setAttribute('height', '100%');
        full.setAttribute('fill', 'white');
        const hole = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        hole.setAttribute('class', 'dw-hole');
        hole.setAttribute('x', '0');
        hole.setAttribute('y', '0');
        hole.setAttribute('width', '0');
        hole.setAttribute('height', '0');
        hole.setAttribute('fill', 'black');
        mask.appendChild(full);
        mask.appendChild(hole);
        defs.appendChild(mask);
        svg.appendChild(defs);
        const dim = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        dim.setAttribute('class', 'dw-dim');
        dim.setAttribute('x', '0');
        dim.setAttribute('y', '0');
        dim.setAttribute('width', '100%');
        dim.setAttribute('height', '100%');
        dim.setAttribute('fill', 'rgba(0,0,0,0.4)');
        dim.setAttribute('mask', 'url(#dw-hole-mask)');
        svg.appendChild(dim);
        layer.appendChild(svg);
    }
    const hole = svg.querySelector('.dw-hole');
    const dimRect = svg.querySelector('.dw-dim');
    if (created) {
        try {
            window.dispatchEvent(new CustomEvent('dw-tour-root-ready'));
        }
        catch {
            /* noop */
        }
    }
    return { host, shadow, mount, layer, svg, hole, dimRect };
}
export function removeTourRoot() {
    const host = document.querySelector('dw-tour-root');
    if (host && host.parentElement)
        host.parentElement.removeChild(host);
}
export function setSpotlightVisible(visible) {
    const { svg } = ensureTourRoot();
    svg.style.display = visible ? 'block' : 'none';
}
export function updateSpotlightRect(rect) {
    const { hole, svg } = ensureTourRoot();
    const r = Math.max(0, Number(rect.radius ?? 10));
    hole.setAttribute('x', String(Math.max(0, rect.x)));
    hole.setAttribute('y', String(Math.max(0, rect.y)));
    hole.setAttribute('width', String(Math.max(0, rect.width)));
    hole.setAttribute('height', String(Math.max(0, rect.height)));
    hole.setAttribute('rx', String(r));
    hole.setAttribute('ry', String(r));
    // ensure SVG is visible if rect updates
    svg.style.display = 'block';
}
export function setMaskPointerEvents(passThrough) {
    const { dimRect } = ensureTourRoot();
    dimRect.style.pointerEvents = passThrough ? 'none' : 'auto';
}
//# sourceMappingURL=ensure-root.js.map